import React, { useEffect, useState, useContext } from 'react';
import { getAssignmentsWithLogs } from '../../services/ClassroomServices';
import { FaMapMarkerAlt, FaCheckSquare, FaKeyboard } from 'react-icons/fa';
import { ClassroomContext } from '../../context/ClassroomContext';
import AuthContext from '../../context/AuthContext';
import styles from './styles/ClassroomGrades.module.css';
import ClassroomSearchSidebar from './ClassroomSearchSidebar';
import { useNavigate, useLocation } from 'react-router-dom';

const ClassroomTeacherGrades = ({ isTeacher }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { classroom, isOwner } = useContext(ClassroomContext);
    const { userId } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [expandedView, setExpandedView] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const [openAssignments, setOpenAssignments] = useState(new Set());

    useEffect(() => {
        if(!isTeacher || !isOwner){
            const newPath = location.pathname.replace('/gt', '/gs');
            navigate(newPath);
        }
        const getStuff = async () => {
            const data = await getAssignmentsWithLogs(classroom._id);
            setData(data);
        };
        getStuff();
    }, [classroom, isTeacher, userId]);

    if (!isTeacher) {
        return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
    }
    
    const getDecisionClass = (decision) => {
        const classes = [styles.decisionItem];
        if (decision.type === 'choice' || decision.type === 'input') {
            if (decision.correctness === 'correct') {
                classes.push(styles.correct);
            } else if (decision.correctness === 'incorrect') {
                classes.push(styles.incorrect);
            }
        }
        return classes.join(' ');
    };

    const toggleAssignment = (id) => {
        setOpenAssignments(prev => {
            const newSet = new Set(prev);
            if (newSet.has(id)) newSet.delete(id);
            else newSet.add(id);
            return newSet;
        });
    };

    const filteredData = data
        .filter((assignment) => !selectedAssignment || assignment._id === selectedAssignment._id)
        .map((assignment) => ({
            ...assignment,
            logs: assignment.logs.filter((log) => !selectedStudent || log.viewer._id === selectedStudent._id)
        }))
        .filter((assignment) => {
            if (!selectedStudent && !selectedAssignment) {
                return true; 
            }
            if (selectedAssignment) {
                return assignment._id === selectedAssignment._id;
            }
            if (selectedStudent) {
                if(assignment.logs.length <= 0) return false;
                return true;
            }
            })
        //.filter((assignment) => assignment.logs.length > 0 || (!selectedStudent && !selectedAssignment));

    const showFilteredOnly = selectedStudent || selectedAssignment;

    return (
        <div className={`${styles.pageContainer}`}>
            <div className={styles.mainContent}>
                {filteredData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)).map((assignment) => (
                    <div key={assignment._id} className={styles.assignmentSection}>
                        <h2
                            className={styles.assignmentTitle}
                            onClick={() => !showFilteredOnly && toggleAssignment(assignment._id)}
                            style={{ cursor: !showFilteredOnly ? 'pointer' : 'default' }}
                        >
                            {assignment.title}
                        </h2>

                        {(showFilteredOnly || openAssignments.has(assignment._id)) && (
                            <>
                                {assignment.logs.length === 0 ? (
                                    <p className={styles.noLogs}>No submissions for this assignment</p>
                                ) : (
                                    assignment.logs
                                        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                                        .map((log, index) => (
                                            <div key={log._id} className={styles.logBlock}>
                                                <p
                                                    onClick={() => setExpandedView(prev => prev === log._id ? null : log._id)}
                                                    className={styles.logItem}
                                                >
                                                    Attempt {assignment.logs.length - index} —{" "}
                                                    {log.grade
                                                        ? `${log.grade}%`
                                                        : !log.isCompleted
                                                        ? "Unfinished"
                                                        : "Ungraded"}{" "}
                                                    - {log?.viewer?.username}
                                                </p>

                                                {expandedView === log._id && (
                                                    log.decisions.length > 0 ? (
                                                        <ul className={styles.decisionList}>
                                                            {log.decisions
                                                                .filter(dec => dec.priority)
                                                                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                                                .map((decision, idx) => (
                                                                    <li key={decision._id || idx} className={getDecisionClass(decision)}>
                                                                        {decision.type === 'situation' && (
                                                                            <>
                                                                                <FaMapMarkerAlt className={styles.decisionIcon} />
                                                                                <span>Question: {decision.title || 'untitled'}</span>
                                                                            </>
                                                                        )}
                                                                        {decision.type === 'choice' && (
                                                                            <>
                                                                                <FaCheckSquare className={styles.decisionIcon} />
                                                                                <span>Choice: {decision.choiceText?.replace(/<[^>]*>/g, '') || 'untitled'}</span>
                                                                            </>
                                                                        )}
                                                                        {decision.type === 'input' && (
                                                                            <>
                                                                                <FaKeyboard className={styles.decisionIcon} />
                                                                                <span>Input: "{decision.userInput}"</span>
                                                                            </>
                                                                        )}
                                                                    </li>
                                                                ))}
                                                        </ul>
                                                    ) : (
                                                        <div className={styles.noDecisions}>
                                                            No decisions recorded in this submission.
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        ))
                                )}
                            </>
                        )}
                    </div>
                ))}
            </div>
            <div className={styles.sidebar}>
                <ClassroomSearchSidebar
                    classroomId={classroom._id}
                    setSelectedStudent={setSelectedStudent}
                    setSelectedAssignment={setSelectedAssignment}
                />
            </div>
        </div>
    );
};

export default ClassroomTeacherGrades;
